module.exports = __webpack_public_path__ + "f55394b353a01bf3269181a18d5b1798.jpg";